import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { PoolService } from './pool.service';

const service = new PoolService();

export interface PoolState {}

const PoolStore: Module<PoolState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getPools(context, query: LocationQuery) {
         return await service.getPools(query);
      },
      async postCandidatePool(context, payload: { poolId: number; candidateIds: Array<number> }) {
         return await service.postCandidatePool(payload.poolId, payload.candidateIds);
      },
   },
};

export default PoolStore;
